import React from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

function ChapterRow({ chapter, onChange, onRemove }) {
  const editor = useEditor({
    extensions: [StarterKit],
    content: chapter.paragraphs_html || "",
    onUpdate: ({ editor }) => onChange({ ...chapter, paragraphs_html: editor.getHTML() }),
  });

  return (
    <div style={{ marginBottom: 24, padding: 12, border: "1px solid #eee", borderRadius: 8 }}>
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
        <input
          type="number"
          min={1}
          value={chapter.index}
          onChange={(e) => onChange({ ...chapter, index: parseInt(e.target.value, 10) })}
          style={{ width: 60, padding: 6 }}
        />
        <input
          placeholder="Roman (ex: Chapitre I)"
          value={chapter.roman}
          onChange={(e) => onChange({ ...chapter, roman: e.target.value })}
          style={{ width: 150, padding: 6 }}
        />
        <input
          placeholder="Titre"
          value={chapter.title}
          onChange={(e) => onChange({ ...chapter, title: e.target.value })}
          style={{ flex: 1, padding: 6 }}
        />
        <button onClick={onRemove}>×</button>
      </div>
      <div style={{ minHeight: 120, border: "1px solid #ddd", borderRadius: 4, padding: 8 }}>
        <EditorContent editor={editor} />
      </div>
      <input
        placeholder="Morale (une phrase)"
        value={chapter.morale}
        onChange={(e) => onChange({ ...chapter, morale: e.target.value })}
        style={{ width: "100%", padding: 8, marginTop: 8 }}
      />
    </div>
  );
}

export default function ChaptersEditor({ chapters, onChange }) {
  const update = (i, c) => onChange(chapters.map((x, idx) => (idx === i ? c : x)));
  const remove = (i) => onChange(chapters.filter((_, idx) => idx !== i));
  const add = () =>
    onChange([
      ...chapters,
      { index: chapters.length + 1, roman: `Chapitre ${chapters.length + 1}`,
        title: "", paragraphs_html: "<p></p>", morale: "" },
    ]);

  return (
    <fieldset style={{ marginBottom: 24 }}>
      <legend><strong>Chapitres ({chapters.length})</strong></legend>
      {chapters.map((c, i) => (
        <ChapterRow
          key={i}
          chapter={c}
          onChange={(next) => update(i, next)}
          onRemove={() => remove(i)}
        />
      ))}
      <button onClick={add}>+ Ajouter un chapitre</button>
    </fieldset>
  );
}
